/**
 * Preamble component
 */

/** Dependencies -------------------------------------------- */

// External

import classNames from 'classnames'

import { useEffect } from 'react'

// Internal

import {
    getPlugin,
    setPreambleAcceptanceCookie
} from '../dictionary'
import { useAppState } from '../state'

import Button from './button'
import Icon from './icon'

/** Main ---------------------------------------------------- */

const baseClassName = 'preamble'

export default function Preamble() {

    // Constants

    const plugin = getPlugin()

    const hasPreamble = useAppState( ( state ) => state.hasPreamble )
    const setHasPreamble = useAppState( ( state ) => state.setHasPreamble )

    const title = plugin.preambleTitle
    const content ={ __html: plugin.preambleContent }

    const consolidatedClassName = classNames(
        baseClassName,
        { 'is-active': hasPreamble }
    )

    // Handlers

    function handleDismiss() {
        setHasPreamble( false )
    }

    function handleAccept() {
        setPreambleAcceptanceCookie( true )
        setHasPreamble( false )
    }

    return (
        <div className={ consolidatedClassName }>
            <div className={ `${baseClassName}__container` }>
                <header className={ `${baseClassName}__header` }>
                    <h2 className={ `${baseClassName}__title` }>
                        { title }
                    </h2>
                    <Button
                        title="Dismiss"
                        type="naked"
                        trailingIconProps={ { type: 'close' } }
                        onClick={ handleDismiss }
                    />
                </header>
                <div className={ `${baseClassName}__content` } dangerouslySetInnerHTML={ content }/>
                <footer className={ `${baseClassName}__footer` }>
                    <Button
                        title="I Understand"
                        onClick={ handleAccept }
                    />
                </footer>
            </div>            
        </div>
    )
}
